import api from 'services';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Chronological key for a model label such as "Jan-25". Unknown labels sort last. */
const periodStamp = (label: string): number => {
  const [month, year] = label.split('-');
  const index = MONTHS.indexOf(month);
  const yy = Number(year);
  if (index < 0 || Number.isNaN(yy)) return Number.MAX_SAFE_INTEGER;
  return yy * 12 + index;
};

/**
 * The dashboard prints a period as "Jan 25", from the model label "Jan-25".
 */
export const periodLabel = (value: string): string => value.replace('-', ' ');

/**
 * Scenario and model time range, in the same order as the dashboard header.
 * Example: "Baseline • Jan 25 to Dec 28".
 */
export const planningContextLine = (scenarioName: string, start: string, end: string): string => {
  const name = scenarioName.trim();
  const range = start && end ? `${periodLabel(start)} to ${periodLabel(end)}` : '';
  if (name && range) return `${name} • ${range}`;
  return name || range;
};

/**
 * Look up the task's scenario and the model's time dimension.
 * The first and last time items are the range the dashboard shows.
 */
export const loadPlanningContext = async (modelId: number, scenarioId: number): Promise<string> => {
  const [scenarios, time] = await Promise.all([
    api.get_scenarios(modelId),
    api.get_model_time(modelId),
  ]);
  const list = (scenarios.data?.scenarios ?? []) as Array<{ id: number; name: string }>;
  const scenario = list.find((item) => Number(item.id) === Number(scenarioId));
  const range = ([...(time.data?.time_range ?? [])] as string[]).sort(
    (left, right) => periodStamp(left) - periodStamp(right),
  );
  const start = range[0] ?? '';
  const end = range[range.length - 1] ?? '';
  return planningContextLine(scenario?.name ?? '', start, end);
};
